import React from 'react'
import { Field } from 'redux-form'
import 'antd/dist/antd.css'

import { DatePicker } from 'antd';

import moment from 'moment'

export class SVEDDInputEp extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.svedcCurryCom = this.svedcCurryCom.bind(me)
        this.state = {
            filters: {

                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
                // "endDate": "2024-07-22T25:42:55.795+00:00" ,
                startDate: new Date()
            }
        }


    }

    svedcCurryCom = (param1, ctxThis) => (o) => {
        console.log("*******svj22****curry** START")
        console.log(param1)

        console.log(ctxThis)

        console.log(o)
        const { input: { onChange, value } } = o
        console.log("*******svj22****redux vaalue**")
        console.log(value)
        let vob = value
        let vob_date = value._d
        console.log(vob_date)
        let STARTDATE_ITN_TZAWARE_EST = "2025-11-25"
        let mo_ss = moment(STARTDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
        let mofval = null
        if (value != null) {
            mofval = moment(vob_date)
            let mofval_str = mofval.format('YYYY-MM-DD')

            console.log("*******svj22****mofval_stre**")

            console.log(mofval_str)



            let mom_value = !value ? mo_ss : mofval_str
        } else {
            mofval = mo_ss
        }

        let TIME_NO = false



        return (<DatePicker showTime={TIME_NO} onChange={onChange} value={mofval} />)


    }
    render() {
        console.log('render SVEDDInputEp date add')

        let me = this
        let { member } = this.props

        let param1 = "1974-01-14"


        return (

            <Field 
            
            name={`${member}.expiryDate`}
                className="form-control"
                component={this.svedcCurryCom(param1, this)}
            />
        )


    }

}